import { TextLink } from '@domgen/base-design-system-2.0/atoms/TextLink';
import { LoadingSpinner } from '@domgen/base-design-system-2.0/atoms/LoadingSpinner';

export const LoadingPage = () => {
  return (
    <div className="fixed top-0 left-0 w-screen h-screen bg-neutral-100 text-neutral-900 flex flex-col justify-center items-center z-50">
      <div className="w-12 h-12">
        <LoadingSpinner />
      </div>

      <h3 className="text-heading-3 mt-4 mb-2">Loading...</h3>
      <p className="px-14 text-center text-body md:max-w-[465px]">
        {'Please wait while we redirect you to the next page. If loading continues, call us on '}
        <span className="inline">
          <TextLink href="tel:+18335522314">+1 833-552-2314</TextLink>
        </span>
      </p>
    </div>
  );
};
